import requestApi from "@/utils/requestApi";
import buyerHeader from "@/components/buyerHeader";
import buyerFooter from "@/components/buyerFooter";
import { mapState } from "vuex";
import SubmitBar from "./components/submit-bar/submit-bar.vue";
import GoodsItem from "./components/goods-item/goods-item.vue";
import VipPrice from "./components/vip-price/vip-price.vue";
import Specification from "./components/specification/specification.vue";

let loading = null;
let submitBarTimer = null;

export default {
  components: {
    VipPrice,
    SubmitBar,
    GoodsItem,
    buyerHeader,
    buyerFooter,
    Specification,
  },
  data() {
    return {
      // list: [
      //   { shopId: 1, goods: [{ id: 1, checked: false, disabled: false }], checked: false },
      //   {
      //     shopId: 2,
      //     goods: [
      //       { id: 2, checked: false },
      //       { id: 3, gift: [{}], disabled: true },
      //       { id: 4, checked: false, disabled: false },
      //     ],
      //     checked: false,
      //   },
      // ],
      app: process.env.VUE_APP_APP,
      list: [],
      originalList: [],
      curGoods: {},
      pageSize: 5,
      skuTotal: 0,
      searchVal: "",
      currentPage: 1,
      listChecked: [],
      checkboxAll: false,
      checkboxAllDisabled: false,
      indeterminate: false,
      submitBarFixed: true,
      vipPriceVisible: false,
      couponMyShopList: [],
      couponMyPlatformList: [],
      userType: 2,
    };
  },
  computed: {
    ...mapState("cart", ["goodsIdChecked"]),
  },
  watch: {
    list: {
      handler: function (data) {
        const normalAllGoods = [];
        const { goodsIdChecked } = this;
        data.forEach((item) => {
          const normalGoods = [];
          item.carItemList.forEach((goods) => {
            if (goods.upDownStatus && goods.currPrice && goods.originalPrice && Number(goods.quantity) >= Number(goods.minOrderQuantity)) {
              if (goodsIdChecked.includes(goods.skuId)) {
                goods.checked = true;
                normalGoods.push(goods);
              }
              normalAllGoods.push(goods);
            }

            if (goods.checked) {
              normalGoods.push(goods);
            }
          });

          if (item.carItemList.every((item2) => item2.checked)) {
            item.checked = true;
            item.indeterminate = false;
          } else {
            item.checked = false;
            if (item.carItemList.some((item2) => item2.checked)) {
              item.indeterminate = true;
            }
          }
        });

        if (!normalAllGoods.length) {
          this.checkboxAllDisabled = true;
        } else {
          this.checkboxAllDisabled = false;
        }

        if (normalAllGoods.length && normalAllGoods.every((item) => item.checked)) {
          this.checkboxAll = true;
          this.indeterminate = false;
        } else {
          this.checkboxAll = false;
          if (normalAllGoods.some((item) => item.checked)) {
            this.indeterminate = true;
          }
        }

        console.log("this.list", this.list);
      },
      deep: true,
    },
  },
  async created() {
    loading = this.$loading({
      lock: false,
      text: "加载中...",
    });

    this.$store.dispatch("shop/shop/getEnterpriseByBoId").then((res) => {
      const { code, msg, data } = res;
      if (code === 0) {
        this.userType = data.Type;
      } else {
        this.$message.error(msg);
      }
    });

    window.addEventListener("scroll", this.submitBarScroll);
    // 221115135078017 221115135078002
    // await requestApi.post("sctrading/shoppingCart/add", {
    //   skuId: "230525180178002",
    //   shopId: "6340867391440008896",
    //   fromShopId: "6340867391440008896",
    //   quantity: 1,
    //   shareBoId: 0,
    //   platformType: "SC",
    // });

    // await requestApi.post("sctrading/shoppingCart/deleteGoods", {
    //   skuIdList: [230516145678002],
    // });

    Promise.all([
      requestApi.post("sctrading/shop/coupon/selMyList", {
        platformType: "SC",
        cpChannel: "SHOP",
      }),
      requestApi.post("sctrading/shop/coupon/selMyList", {
        platformType: "SC",
        cpChannel: "PLATFORM",
      }),
    ]).then(([shopRes, platformRes]) => {
      const { data: shopData } = shopRes;
      const { data: platformData } = platformRes;

      if (shopData && shopData.length) {
        shopData.forEach((item) => {
          item.shopCouponList = item.shopCouponList.map((coupon) => ({
            ...coupon,
            myCoupon: true,
          }));
        });
        this.couponMyShopList = shopData;
      }

      if (platformData && platformData[0] && platformData[0].shopCouponList && platformData[0].shopCouponList.length) {
        this.couponMyPlatformList = platformData[0].shopCouponList.map((item) => ({
          ...item,
          busType: "platform",
          myCoupon: true,
        }));
      }

      this.loadData();
    });
  },
  beforeDestroy() {
    submitBarTimer && clearTimeout(submitBarTimer);
    submitBarTimer = null;
    window.removeEventListener("scroll", this.submitBarScroll);
  },
  methods: {
    async loadData() {
      loading = this.$loading({
        lock: false,
        text: "加载中...",
      });

      const { data } = await requestApi.post("sctrading/shoppingCart/selList", {});
      const { skuTotal, shopGoodsList } = data;
      let ids = shopGoodsList.map((item) => item.shopId);
      let coupon = [];
      if (ids.length) {
        let { data: Rescoupon } = await requestApi.post("sctrading/shop/coupon/selListByShopIdList", {
          shopIdList: ids,
        });

        coupon = Rescoupon;
      }

      const { couponMyShopList, couponMyPlatformList } = this;

      shopGoodsList.forEach((item) => {
        item.shopCouponList = [];
      });

      coupon.forEach((item) => {
        item.shopCouponList.forEach((item2) => {
          item2.couponText = "";
          item2.isCouponLimit = false;
        });
      });

      shopGoodsList.forEach((item) => {
        const shopCouponIndex = coupon.findIndex((couponItem) => couponItem.shopId == item.shopId);
        if (shopCouponIndex != -1) {
          if (item.shopCouponList && item.shopCouponList.length) {
            item.shopCouponList = [...item.shopCouponList, ...coupon[shopCouponIndex].shopCouponList];
          } else {
            item.shopCouponList = coupon[shopCouponIndex].shopCouponList;
          }
        }

        const couponMyShopListIndex = couponMyShopList.findIndex((couponItem) => couponItem.busId == item.shopId);
        if (couponMyShopListIndex != -1) {
          if (item.shopCouponList && item.shopCouponList.length) {
            item.shopCouponList = [...item.shopCouponList, ...couponMyShopList[couponMyShopListIndex].shopCouponList];
          } else {
            item.shopCouponList = [...couponMyShopList[couponMyShopListIndex].shopCouponList];
          }
        }

        if (couponMyPlatformList && couponMyPlatformList.length) {
          if (item.shopCouponList && item.shopCouponList.length) {
            item.shopCouponList = [...item.shopCouponList, ...couponMyPlatformList];
          } else {
            item.shopCouponList = [...couponMyPlatformList];
          }
        }

        const normalGoods = item.carItemList.filter((goods) => goods.upDownStatus && goods.currPrice && goods.originalPrice);
        if (!normalGoods.length) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        item.checked = false;
        item.carItemList.forEach((goods) => {
          goods.checked = false;
          if (Number(goods.quantity) > Number(goods.currQuantity)) {
            goods.disabled = true;
          }
        });
      });

      this.list = shopGoodsList;
      this.originalList = shopGoodsList;
      this.skuTotal = skuTotal;
      loading.close();
    },
    submitBarScroll() {
      clearTimeout(submitBarTimer);
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      setTimeout(() => {
        if (scrollTop >= documentHeight - windowHeight - document.querySelector(".foot").offsetHeight - document.querySelector(".foot").offsetHeight + 200) {
          this.submitBarFixed = false;
        } else {
          this.submitBarFixed = true;
        }
      }, 100);
    },
    /* 全选 */
    checkboxAllChange(checked) {
      this.list.forEach((item) => {
        if (!checked) {
          item.indeterminate = false;
        }
        item.carItemList.forEach((goods) => {
          if (goods.upDownStatus && goods.currPrice && goods.originalPrice && Number(goods.quantity) >= Number(goods.minOrderQuantity)) {
            goods.checked = checked;
          }
        });
      });
    },
    /* 更改页码 */
    currentChange(val) {
      this.currentPage = val;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop > 0) {
        window.scrollTo({
          top: 0,
        });
      }
    },
    /* 搜索 */
    searchSubmit() {
      this.currentPage = 1;

      const { originalList, searchVal } = this;
      if (searchVal) {
        const listTem = [];
        originalList.forEach((item) => {
          if (item.shopName.toLowerCase().includes(searchVal.toLowerCase())) {
            listTem.push(item);
          } else {
            const carItemList = [];
            item.carItemList.forEach((goods) => {
              if (goods.skuName.toLowerCase().includes(searchVal.toLowerCase())) {
                carItemList.push(goods);
              }
            });
            if (carItemList.length) {
              listTem.push({
                ...item,
                carItemList,
              });
            }
          }
        });
        console.log("listTem", listTem);
        this.list = listTem;
        return;
      }

      this.list = originalList;
    },
  },
};
